<div class="mb-3">
  <div>
    <h1 class="pb-2 border-bottom fw-light" i18n>Meine Daten</h1>

    <kendo-tabstrip>
      <kendo-tabstrip-tab title="Allgemein" i18n-title [selected]="true">
        <ng-template kendoTabContent>
          <div class="content">
            <kendo-pdf-export #pdf paperSize="A4" margin="2cm" [scale]="0.75">
              <div class="row">
                <div class="col-sm-6">
                  <div class="row mb-2">
                    <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n
                      >Kundenname</label
                      >
                      <div class="col-sm-8">
                        <label class="col-form-label col-form-label-sm" data-testid="profile-customer-fullname">{{
                          profile.customer.fullName
                        }}</label>
                      </div>
                    </div>

                    <div class="row mb-2">
                      <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n
                        >Kundennummer</label
                        >
                        <div class="col-sm-8">
                          <label class="col-form-label col-form-label-sm">{{
                            profile.customer.customerNumber
                          }}</label>
                        </div>
                      </div>

                      <div class="row mb-2">
                        <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n
                          >Vorname</label
                          >
                          <div class="col-sm-8">
                            <label class="col-form-label col-form-label-sm">{{
                              profile.customer.firstName
                            }}</label>
                          </div>
                        </div>

                        <div class="row mb-2">
                          <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n
                            >Mittelname</label
                            >
                            <div class="col-sm-8">
                              <label class="col-form-label col-form-label-sm">{{
                                profile.customer.middleName
                              }}</label>
                            </div>
                          </div>

                          <div class="row mb-2">
                            <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n
                              >Nachname</label
                              >
                              <div class="col-sm-8">
                                <label class="col-form-label col-form-label-sm">{{
                                  profile.customer.lastName
                                }}</label>
                              </div>
                            </div>

                            <div class="row mb-2">
                              <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n
                                >Straße</label
                                >
                                <div class="col-sm-8">
                                  <label class="col-form-label col-form-label-sm">{{
                                    profile.customer.street
                                  }}</label>
                                </div>
                              </div>

                              <div class="row mb-2">
                                <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n
                                  >PLZ</label
                                  >
                                  <div class="col-sm-8">
                                    <label class="col-form-label col-form-label-sm">{{
                                      profile.customer.zipCode
                                    }}</label>
                                  </div>
                                </div>

                                <div class="row mb-2">
                                  <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n
                                    >Ort</label
                                    >
                                    <div class="col-sm-8">
                                      <label class="col-form-label col-form-label-sm">{{
                                        profile.customer.city
                                      }}</label>
                                    </div>
                                  </div>

                                  <div class="row mb-2">
                                    <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n
                                      >E-Mail</label
                                      >
                                      <div class="col-sm-8">
                                        <label class="col-form-label col-form-label-sm">{{
                                          profile.customer.email
                                        }}</label>
                                      </div>
                                    </div>

                                    <div class="row mb-2">
                                      <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n
                                        >Telefon</label
                                        >
                                        <div class="col-sm-8">
                                          <label class="col-form-label col-form-label-sm">{{
                                            profile.customer.phone
                                          }}</label>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-sm-6">
                                      <div class="row mb-2">
                                        <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n
                                          >Kontoart</label
                                          >
                                          <div class="col-sm-8">
                                            <label class="col-form-label col-form-label-sm">
                                              @if (profile.customer.isRetailer) {
                                                <ng-container i18n>Gewerblicher Anbieter</ng-container>
                                              } @else {
                                                <ng-container i18n>Privater Anbieter</ng-container>
                                              }
                                            </label>
                                          </div>
                                        </div>

                                      <div class="row mb-2">
                                        <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n
                                          >Angemeldet als</label
                                          >
                                          <div class="col-sm-8">
                                            <label class="col-form-label col-form-label-sm">{{
                                              profile.user.fullName
                                            }}</label>
                                          </div>
                                        </div>

                                        <div class="row mb-2">
                                          <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n
                                            >Rolle</label
                                            >
                                            <div class="col-sm-8">
                                              <label class="col-form-label col-form-label-sm">{{ profile.role }}</label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </kendo-pdf-export>

                                    <button
                                      class="btn btn-secondary m-2"
                                      (click)="pdf.saveAs('MeineDaten.pdf')"
                                      i18n
                                      >
              <fa-icon [icon]="faFilePdf" class="me-2"></fa-icon>PDF Export...
            </button>

                                    <button
                                      class="btn btn-danger m-2"
                                      type="button"
                                      data-testid="profile-delete-button"
                                      [asyncClick]="deleteProfile.bind(this)"
                                      [lockGroup]="profileLock"
                                      [disabled]="deleteBtn.disabled"
                                      #deleteBtn="asyncClick"
                                      i18n
                                      >
              @if (deleteBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
              Profil löschen
            </button>
                                  </div>

                                  <button class="btn btn-primary mt-5" type="button" (click)="onBackClicked()" i18n>
            Zurück
          </button>
                                </ng-template>
                              </kendo-tabstrip-tab>

                              @if (isAdmin) {
                                <kendo-tabstrip-tab title="Kontaktdaten" i18n-title>
                                  <ng-template kendoTabContent>
                                    <div class="content">
                                      <app-customer-contact-edit></app-customer-contact-edit>
                                      <button class="btn btn-primary mt-5" type="button" (click)="onBackClicked()" i18n>
                                        Zurück
                                      </button>
                                    </div>
                                  </ng-template>
                                </kendo-tabstrip-tab>
                              }

                              <kendo-tabstrip-tab title="Anbieterdaten" i18n-title>
                                <ng-template kendoTabContent>
                                  <div class="content">

                                    <div class="mt-3">
                                      <form [formGroup]="customerForm">
                                        <h2 class="pb-2 border-bottom" i18n>Firmenlogo</h2>

                                        <div class="row mt-4 mb-2">
                                          <div class="row">
                                            <label class="col-sm-4 col-form-label col-form-label-sm" i18n>Firmenlogo</label>
                                          </div>
                                          <div class="row">
                                            <small class="text-muted">
                                              <p i18n>Das Firmenlogo wird in Rechnungsdokumenten angezeigt.</p>
                                            </small>
                                          </div>
                                          <div class="row m-1">
                                            <img [src]="largeImageFile" class="img-fluid col-sm-3" alt="" />
                                          </div>

                                          <div class="row">
                                            <div class="col-sm-10">
                                              <kendo-fileselect
                                                formControlName="largeFiles"
                                                [multiple]="false"
                                                (select)="selectImageEventHandler($event, true)"
                                                >
                                                <!-- #178 slice E: kept inline on purpose. Every other Kendo text now comes from
                                                KendoMessagesService, but this one continues the sentence above it and differs per
                                                picker („Datei" here, „Bilddatei" in the profile) — one global string cannot be
                                                both. Everything else this file-select says comes from the service. -->
                                                <kendo-fileselect-messages
                                                  i18n-dropFilesHere
                                                  dropFilesHere="...oder Bilddatei hier ablegen"
                                                  i18n-select
                                                  select="Auswählen"
                                                  >
                                                </kendo-fileselect-messages>
                                              </kendo-fileselect>
                                            </div>
                                          </div>
                                        </div>

                                        <button class="btn btn-primary m-2" type="button" [asyncClick]="submitForm.bind(this)" [lockGroup]="profileLock" [disabled]="saveBtn.disabled || customerForm.invalid" #saveBtn="asyncClick" i18n>
                                          @if (saveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
                                          Bestätigen
                                        </button>
                                      </form>

                                    </div>

                                    <div class="mt-3">

                                      <app-custom-seller-info-edit></app-custom-seller-info-edit>

                                    </div>

                                  </div>

                                  <button class="btn btn-primary mt-5" type="button" (click)="onBackClicked()" i18n>
            Zurück
          </button>
                                </ng-template>
                              </kendo-tabstrip-tab>

                              <kendo-tabstrip-tab title="Benutzerdaten" i18n-title>
                                <ng-template kendoTabContent>
                                  <div class="content">
                                    <div class="row">
                                      <div class="col-sm-6">
                                        <div class="row mb-2">
                                          <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n>Anmeldename</label>
                                          <div class="col-sm-8">
                                            <label class="col-form-label col-form-label-sm">{{ profile.user.username }}</label>
                                          </div>
                                        </div>
                                        <div class="row mb-2">
                                          <label class="col-sm-4 col-form-label col-form-label-sm fw-bold" i18n>Rolle</label>
                                          <div class="col-sm-8">
                                            <label class="col-form-label col-form-label-sm">{{ profile.role }}</label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <app-user-name-edit></app-user-name-edit>
                                    <button class="btn btn-primary m-2" type="button" (click)="onBackClicked()" i18n>
                                      Zurück
                                    </button>
                                  </div>
                                </ng-template>
                              </kendo-tabstrip-tab>

                              <kendo-tabstrip-tab title="Zwei-Faktor-Authentifizierung" i18n-title>
                                    <ng-template kendoTabContent>
                                      <app-tfa-configuration></app-tfa-configuration>
                                    </ng-template>
                                  </kendo-tabstrip-tab>
                                </kendo-tabstrip>
                              </div>
                            </div>
